var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:(_vm.titleTop),expression:"titleTop"}]},[_c('van-skeleton',{attrs:{"title":"","row":20,"loading":_vm.loading}},[_vm._v("\n    Loading...\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }